export const profile = {
  title: 'Profile settings',
  personalInfo: 'Personal information',
  fullName: 'Full name',
  email: 'Email address',
  phone: 'Phone number',
  changePassword: 'Change password',
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmPassword: 'Confirm new password',
  updatePassword: 'Change password'
}
